import { render, staticRenderFns } from "./DatavDesignPreviewItem.vue?vue&type=template&id=60d00efe&scoped=true"
import script from "./DatavDesignPreviewItem.vue?vue&type=script&lang=js"
export * from "./DatavDesignPreviewItem.vue?vue&type=script&lang=js"
import style0 from "./DatavDesignPreviewItem.vue?vue&type=style&index=0&id=60d00efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d00efe",
  null
  
)

export default component.exports